import Slider from 'react-slick';   
import  './KeepGuest.css';

const PrevArrow = (props) => (
    <button {...props} className="slick-prev">
      <img src="/img/rentshield/claims_arrow_left.svg" alt="Previous" width="48" height="48" />
    </button>
  );
  
  const NextArrow = (props) => (
    <button {...props} className="slick-next">
      <img src="/img/rentshield/claims_arrow_right.svg" alt="Next" width="48" height="48" />
    </button>
  );


const KeepGuest = ()=>{

// START cards
  // const cards = [
  //   { 
  //     id: 1, 
  //     image: '/img/Solutions/door_pink.svg',
  //     heading: 'Convenient Check-In', 
  //     text: 'Skip long car rental lines and have a car waiting at their vacation home.' },
  //   { 
  //     id: 2, 
  //     image: '/img/Solutions/money_pink.svg',
  //     heading: 'Cost Savings', 
  //     text: 'Avoid high airport rental fees and surge pricing.' },
  //   { 
  //     id: 3, 
  //     image: '/img/Solutions/calendar_pink.svg',
  //     heading: 'Seamless Booking', 
  //     text: 'Reserve stay and vehicle in one step, enhancing their travel planning.' },
  //   { 
  //     id: 4, 
  //     image: '/img/Solutions/car_pink.svg',
  //     heading: 'Exclusive Local Access', 
  //     text: 'Provide recommendations and insider tips, for authentic experiences.' },
  //   { 
  //     id: 5, 
  //     image: '/img/Solutions/home_pink.svg',
  //     heading: 'Better Vehicle Availability', 
  //     text: 'No need to worry about rental car shortages or unavailability.' },
  //   { 
  //     id: 6, 
  //     image: '/img/Solutions/road_pink.svg',
  //     heading: 'More Freedom & Flexibility', 
  //     text: 'Exploration on their own schedule without taxis or public transport.' },
  //   { 
  //     id: 7, 
  //     image: '/img/Solutions/thumbs_pink.svg',
  //     heading: 'Familiar & Reliable Ride', 
  //     text: 'Quality, well-maintained hosted vehicles ensuring smooth & safe ride.' },
  //  ];
// END cards


// START slick
const settings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  margin: 30,
  autoplay: true,
  autoplaySpeed: 2000,

  // autoplaySpeed: 0,  // No delay between scrolls
  // speed: 4000,  // Smooth continuous movement
  // cssEase: 'linear',

  loop: true,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  centerPadding: '30px',
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        infinite: true,
        margin: 30,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        margin: 20,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Correcting the key to 'slidesToShow'
        centerPadding: "30px",
      },
    },
  ],
};
// END slick


    return(
        <>
            {/* START keepGuestMain */}
            <section className="keepGuestMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="keepGuesteHead">
                                <h2>Keep Guests Coming Back</h2>
                                <p>Offer even more tailored experiences</p>
                            </div>
                        </div>
                    </div>
                  </div>
                  

                <div className='row justify-content-center'>
                  <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      <Slider {...settings}>  
                          <div className="item">
                            <div className="keepGuestDetail">
                              <img className="img-fluid" src="/img/Solutions/door_pink.svg" alt="Convenient Check-In" />
                              <h3>Convenient <br/>Check-In</h3>
                              <p>Skip long car rental lines and have a<br/> car waiting at their vacation home.</p>
                            </div>
                          </div>
                          <div className="item">
                            <div className="keepGuestDetail">
                              <img className="img-fluid" src="/img/Solutions/money_pink.svg" alt="Cost Savings" />
                              <h3>Cost <br/>Savings</h3>
                              <p>Avoid high airport rental fees<br/> and surge pricing.</p>
                            </div>
                          </div>
  
                          <div className="item">
                            <div className="keepGuestDetail">
                              <img className="img-fluid" src="/img/Solutions/calendar_pink.svg" alt="Seamless Booking" />
                              <h3>Seamless <br/>Booking</h3>
                              <p>Reserve stay and vehicle in one step,<br/> enhancing their travel planning.</p>
                            </div>
                          </div>
                          <div className="item">
                            <div className="keepGuestDetail">
                              <img className="img-fluid" src="/img/Solutions/car_pink.svg" alt="Exclusive Local Access" />
                              <h3>Exclusive <br/>Local Access</h3>
                              <p>Provide recommendations and insider<br/> tips, for authentic experiences.</p>
                            </div>
                          </div>

                          <div className="item">
                            <div className="keepGuestDetail">
                              <img className="img-fluid" src="/img/Solutions/home_pink.svg" alt="Better Vehicle Availability" />
                              <h3>Better Vehicle <br/>Availability</h3>
                              <p>No need to worry about rental car<br/> shortages or unavailability.</p>
                            </div>
                          </div>
                          <div className="item">
                            <div className="keepGuestDetail">
                              <img className="img-fluid" src="/img/Solutions/road_pink.svg" alt="More Freedom & Flexibility" />
                              <h3>More Freedom<br/> & Flexibility</h3>
                              <p>Exploration on their own schedule<br/> without taxis or public transport.</p>
                            </div>
                          </div>

                          <div className="item">
                            <div className="keepGuestDetail">
                              <img className="img-fluid" src="/img/Solutions/thumbs_pink.svg" alt="Familiar & Reliable Ride" />
                              <h3>Familiar & <br/>Reliable Ride</h3>
                              <p>Quality, well-maintained hosted<br/> vehicles ensuring smooth & safe ride.</p>
                            </div>
                          </div>

                      </Slider> 
    
                  </div>
                </div>  

                  {/* <div className="keepGuestSlider">
                      <div className="carousel-container mt-2">
                          <div className="carousel">
                                <div className="carousel-track ">
                                  {cards.map((card) => (
                                    <div key={card.id} className="keepGuestDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                      
                                <div className="carousel-track ">
                                  {cards.map((card) => (
                                    <div key={`duplicate-${card.id}`} className="keepGuestDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                          </div>
                      </div>
                  </div> */}
            </section>
            {/* END keepGuestMain */}
        </>
    )
}

export default KeepGuest;